<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Cargos</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="form-inline">
            <input
              class="form-control form-control-sm rounded bright"
              placeholder="Search"
              v-model="searchtext"
              type="text"
              style="width: 500px"
              v-on:keyup.enter="filterData"
            />
            <button
              class="btn btn-link btn-sm"
              type="button"
              v-on:click="filterData"
              style="width: 60px"
            >
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>
          <br />
          <div class="row">
            <div class="form-inline justify-content-sm-end">
              <input
                class="form-control text-center form-control-sm rounded bright"
                placeholder="Serie"
                v-model="search.cargo_serie"
                type="text"
                style="width: 80px; text-transform: uppercase"
                v-on:keyup.enter="filterData"
              />
              &nbsp;&nbsp;
              <input
                class="form-control form-control-sm rounded bright"
                placeholder="Nit cliente"
                v-model="search.cliente"
                type="text"
                v-on:keyup.enter="filterData"
                style="width: 100px; text-transform: uppercase"
              />
              &nbsp;&nbsp;
              <input
                class="form-control form-control-sm rounded bright"
                placeholder="#"
                v-model="search.numero"
                type="text"
                style="width: 75px; text-transform: uppercase"
                v-on:keyup.enter="filterData"
              />
              &nbsp;&nbsp;
              <input
                type="date"
                v-model="search.fecha"
                style="width: 140px"
                class="form-control form-control-sm rounded bright"
              />
              &nbsp;&nbsp;
              <select
                class="form-control form-control-sm rounded bright"
                v-model="filtro_tienda"
                @change="filterData"
                style="width: 150px"
              >
                <option value>Tiendas</option>
                <option
                  v-for="data in tiendas"
                  :value="data.codigo"
                  v-bind:key="data.id"
                >
                  {{ data.nombre }}
                </option>
              </select>
              <select
                class="form-control form-control-sm rounded bright"
                v-model="filtro_estado"
                @change="filterData"
                style="width: 108px"
              >
                <option value>Estatus</option>
                <option value="9">Anulado</option>
                <option value="A">Abierto</option>
                <option value="B">Cerrado</option>
                <option value="E">IMPRESA</option>
              </select>
              <div class="input-group-append">
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  v-on:click="filterData"
                  style="width: 60px"
                >
                  <i class="fa fa-search"></i>
                  Buscar
                </button>
                <button
                  class="btn btn-link btn-sm"
                  type="button"
                  v-on:click="clearFilterData"
                  style="width: 30px"
                >
                  <i class="fa fa-times"></i>
                  Limpiar Datos
                </button>
              </div>
            </div>
          </div>
        </div>
        <CargoTableComponent :data="data" />
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="onPageChange"
        />
      </div>
     </div>
  </div>
</template>
<script>
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CargoTableComponent from "@/components/cxc/cargos/CargoTableComponent";
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    CargoTableComponent,
    UsuarioEnTablaComponent,
    PaginationComponent,
  },
  data() {
    return {
      data: {},
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      filtro_tienda: "",
      search: {},
      tiendas: "",
    };
  },
  mounted() {
    let self = this;
    self.refreshData();
    self.refreshTienda();
  },
  methods: {
    refreshTienda() {
      let self = this;
      DynamicService.fetch("cat", "tiendas", { quitar_paginacion: true }).then((response) => {
        self.tiendas = response.data;
      });
    },
    convertFormatDate(search) {
      search.fecha_creacion = moment(search.fecha).format("DD/MM/YYYY");
    },
    onPageChange(page) {
      let self = this;
      this.currentPage = page;
      DynamicService.fetch("cxc", "cargos", {
        page: page,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      }).then((response) => {
        self.data = response.data;
      });
    },
    refreshData() {
      let self = this;
      DynamicService.fetch("cxc", "cargos").then((response) => {
        self.data = response.data;
      });
    },
    filterData() {
      this.$data.currentPage = 1;
      if (this.search.fecha) {
        this.convertFormatDate(this.search);
      }
      DynamicService.fetch("cxc", "cargos", {
        page: this.$data.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
        tienda: this.filtro_tienda,
        cargo_serie: this.search.cargo_serie,
        cliente: this.search.cliente,
        numero: this.search.numero,
        fecha: this.search.fecha_creacion,
      })
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
          this.data = "";
        });
    },
    clearFilterData() {
      this.filtro_tienda = "";
      this.filtro_estado = "";
      this.searchtext = "";
      this.search = {
        cargo_serie: "",
        cliente: "",
        numero: "",
        fecha: "",
      };
      this.$data.currentPage = 1;
      this.filterData();
    },
  },
};
</script>
